const sessionKey = `PAGE_LIVE_SESSION_ID`

export const formateDateToYYYYMMDDHHMMSS = () => {
  const date = new Date()
  const year = date.getFullYear()
  const _month = date.getMonth() + 1
  const month = _month < 10 ? `0${_month}` : _month
  const _day = date.getDate()
  const day = _day < 10 ? `0${_day}` : _day

  const _hours = date.getHours()
  const hours = _hours < 10 ? `0${_hours}` : _hours

  const _minutes = date.getMinutes()
  const minutes = _minutes < 10 ? `0${_minutes}` : _minutes

  const _seconds = date.getSeconds()
  const seconds = _seconds < 10 ? `0${_seconds}` : _seconds

  return `${year}${month}${day}${hours}${minutes}${seconds}`
}

export const getRandomNum = (num) => {
  return Math.random().toFixed(num).slice(-num)
}

export const getSessionId = () => {
  const id = window.sessionStorage.getItem(sessionKey)
  if (id) {
    return id
  } else {
    return generateSessionId()
  }
}

export const generateSessionId = () => {
  const base = formateDateToYYYYMMDDHHMMSS()
  const randomNum = getRandomNum(6)
  const result = `${base}${randomNum}`
  window.sessionStorage.setItem(sessionKey, result)
  return result
}